import { FC, ReactNode } from 'react';

import { useComparison } from '@screens/Comparison';
import { CharacteristicGroupType } from '@shared/types/characteristics';
import { Container } from '@shared/ui/Container';
import { VStack } from '@shared/ui/Stack';

import { getCellValue } from '../../../utils/getCellValue/getCellValue';
import { getSlidesQuantity } from '../../../utils/getSlidesQuantity/getSlidesQuantity';
import cls from './CharacteristicsSlider.module.scss';

type CharacteristicsSliderProps = {
  characteristics?: CharacteristicGroupType[];
};

export const CharacteristicsSlider: FC<CharacteristicsSliderProps> = ({ characteristics }) => {
  const { products, activeCategory, activeSlideIndex } = useComparison();

  return (
    <div className={cls.wrap}>
      <Container>
        <div className={cls.title}>Основные характеристики</div>
        <VStack className={cls.categoryWrapper}>
          {characteristics
            ? characteristics.map(({ id, label, items }) => (
                <div key={id}>
                  <div className={cls.categoryTitle}>{label}</div>
                  <div>
                    {items.reduce((acc: ReactNode[], { id: attrId, visible, name }) => {
                      if (visible) {
                        acc.push(
                          <div
                            key={attrId}
                            className={cls.item}
                          >
                            <div className={cls.label}>{name}</div>
                            <div className={cls.row}>
                              {Object.keys(products[activeCategory])
                                .splice(activeSlideIndex, getSlidesQuantity())
                                .map((productKey) => {
                                  return (
                                    <div
                                      key={productKey}
                                      className={cls.cel}
                                    >
                                      {getCellValue(products[activeCategory][productKey].props[attrId])}
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        );
                      }

                      return acc;
                    }, [])}
                  </div>
                </div>
              ))
            : null}
        </VStack>
      </Container>
    </div>
  );
};
